/**
 * Copyright (C) 2018–2020 HERE Global B.V. and its affiliate(s).
 * All rights reserved.
 *
 * This software and other materials contain proprietary information
 * controlled by HERE and are protected by applicable copyright legislation.
 * Any use and utilization of this software and other materials and
 * disclosure to any third parties is conditional upon having a separate
 * agreement with HERE for the access, use, utilization or disclosure of this
 * software. In the absence of such agreement, the use of the software is not
 * allowed.
 */

import cssDefault from 'lui-default.scss'

window.lui = window.lui || {}
window.lui.components = window.lui.components || []

window.lui.registerCss = function(css, id) {
  if (document.querySelector(`#${id}`)) return

  if (css) {
    const el = document.createElement('style')
    if (window.lui.applyCssPolyfill) {
      css = window.lui.applyCssPolyfill(css)
    }
    el.innerHTML = css
    el.id = id + '-style'
    document.querySelector('head').appendChild(el)
  }
}

window.lui.registerComponent = (componentClass, css, options) => {
  if (window.customElements.get(componentClass.is)) {
    return
  }
  window.customElements.define(componentClass.is, componentClass, options)
  window.lui.registerCss(css, componentClass.is)
}

window.lui.themes = {}
window.lui.themeCss = {root: cssDefault}

export default window.lui



//////////////////
// WEBPACK FOOTER
// ./packages/lui-init/lui.js
// module id = 148
// module chunks = 0 1 39